<template>
    <el-popover
        placement="left"
        width="130"
        trigger="click"
        class="rp-close-chat"
        popper-class="rp-close-chat_popper"
        >
        <div slot="reference">
            <i class="el-icon-more" />
        </div>
        <el-button :disabled="closingChat" :loading="closingChat" plain class="btn-inner" @click="closeChat">{{ $t('homeScreen.endChat') }}</el-button>
    </el-popover>
</template>
<script>
export default {

    props: {
        closingChat: Boolean  
    },
    methods: {
        closeChat() {
            this.$emit('closeChat', {})
        }
    }
}
</script>
<style lang="scss">
.rp-close-chat {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color .25s;
    margin-left: 15px;
    .el-icon-more {
        transform: rotate(90deg);
    }
    &:hover {
        background-color: rgba(0,0,0,0.25);
    }
}
.rp-close-chat_popper {
    padding: 0px !important;
    .btn-inner {
        padding: 20px 15px !important;
        border: 0px !important;
        color: #000000;
    }
}
</style>